import React from 'react';
import { humanCalculators } from './ConstantsHumanCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'Kalkulator Waktu dan Tanggal - Kalkulator Gratis untuk Menghitung Usia dan Perbedaan Tanggal';
const DESCRIPTION = 'Jelajahi kumpulan kalkulator waktu dan tanggal gratis, termasuk kalkulator usia dalam kalender Masehi dan Hijriah serta kalkulator perbedaan tanggal.';
const KEYWORDS = 'kalkulator waktu dan tanggal, kalkulator gratis, kalkulator usia, perbedaan tanggal, kalkulator kalender';
const OG_URL = 'https://do-calculate.com/id/date-time-calculators';
function CalculatorsList() {
    return (
        <div className="container ">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table className="table table-bordered">
                <thead>
                    <tr >
                        <th >Kalkulator</th>
                        <th >Deskripsi</th>
                    </tr>
                </thead>
                <tbody>
                    {humanCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;